<p>products-redorder works!</p>
